<template>
    <main-layout>
        <inertia-head>
            <title>User Panel</title>
        </inertia-head>

        <template #header>
            <header-component></header-component>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto px-4 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <div class="font-medium text-xl text-secondary mb-2">
                            Welcome back, {{ $page.props.auth.user.name }}!
                        </div>

                        <div class="flex flex-wrap">
                            <inertia-link
                                class="mr-4 my-2"
                                :href="route('register')"
                                v-if="hasPermission('create-user')"
                            >
                                <button-component type="button">
                                    Add User
                                </button-component>
                            </inertia-link>

                            <inertia-link
                                class="my-2"
                                :href="route('manage-user')"
                                v-if="hasPermission('manage-user')"
                            >
                                <button-component type="button">
                                    Manage Users
                                </button-component>
                            </inertia-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from "@/Layouts/Main";
import HeaderComponent from "@/Components/Dashboard/Header";
import ButtonComponent from "@/Components/Button";

export default {
    components: {
        MainLayout,
        HeaderComponent,
        ButtonComponent,
    },
    computed: {
        user() {
            return this.$page.props.auth.user;
        },
        permissions() {
            let result = [];
            if (this.user && this.user.hasOwnProperty("permissionList")) {
                result = this.user.permissionList;
            }
            return result;
        },
    },
    methods: {
        hasPermission(permission) {
            return this.permissions.includes(permission);
        },
    },
};
</script>
